import type { ChangeEvent, Ref, RefObject } from 'react';
import type { ResponsiveStylesProp } from 'client/widget-components/responsive-styles/responsiveStylesService';

export interface SearchPopupStyles {
    iconBtn?: ResponsiveStylesProp;
    input?: ResponsiveStylesProp;
    inputFocus?: ResponsiveStylesProp;
    popup?: ResponsiveStylesProp;
    dropdown?: ResponsiveStylesProp;
    dropdownItemHover?: ResponsiveStylesProp;
}

export enum SearchLayout {
    ROUND = 'round',
    SQUARE = 'square',
}

export interface SearchPopupContentProps {
    inputRef: RefObject<HTMLInputElement> | null;
    styles?: SearchPopupStyles;
    placeholder?: string;
    inputValue: string;
    onInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
    onInputFocus: () => void;
    onClosePopup: () => void;
    collections: Collection[];
    isResultsShown: boolean;
    isLoading: boolean;
    fetchMore: (name: string) => void | Promise<void>;
    animatedBlockRef?: Ref<HTMLDivElement>;
    animationState: string;
}

export interface CollectionItem {
    data: {
        identifier: string;
        name: string;
        image: string;
        displayed_price: string;
    };
    page_item_url: string;
}

export interface Collection {
    name: string;
    path: string;
    items: CollectionItem[];
    page: {
        pageNumber: number;
        totalPages: number;
    };
}

export type CollectionsToSearch = Array<{
    name: string;
    path: string;
}>;
